import React from 'react'

import Section from '../../../../../../components/Section'
import { Purchase } from '../../../types'

type Props = {
    theme: string
    purchaseAction: boolean
    purchaseGuid: string | undefined
    purchasesLoading: boolean
    purchasesError: string | null
    purchase: Purchase
}

const PurchaseSummingup: React.FC<Props> = (props) => {
    return (
        <Section title="Подведение итогов">
            <fieldset disabled={props.purchaseAction}>
                <div className="flex flex-col w-full gap-3">
                    {props.purchaseAction ? (
                        <>
                            <>
                                {props.purchase?.placing_procedure
                                    ?.summingup_date_time && (
                                    <div className="flex flex-row w-full gap-x-5 items-start justify-start ">
                                        <div className="flex flex-col w-[200px]">
                                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                                Дата подведения итогов
                                            </label>
                                            <input
                                                type="date"
                                                className={`form-input user-input-placeholder w-full`}
                                                value={props.purchase.placing_procedure.summingup_date_time.slice(
                                                    0,
                                                    10
                                                )}
                                                style={{
                                                    colorScheme:
                                                        props.theme == 'dark'
                                                            ? 'dark'
                                                            : 'light',
                                                }}
                                            />
                                        </div>
                                    </div>
                                )}
                            </>
                            <>
                                {props.purchase?.placing_procedure
                                    ?.summingup_place && (
                                    <div className="flex flex-col w-full items-start justify-start ">
                                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                            Место подведения итогов
                                        </label>
                                        <textarea
                                            className={`form-textarea w-full`}
                                            maxLength={2000}
                                            rows={3}
                                            value={
                                                props.purchase
                                                    ?.placing_procedure
                                                    ?.summingup_place || ''
                                            }
                                        />
                                    </div>
                                )}
                            </>
                        </>
                    ) : (
                        <>
                            <div className="flex flex-row w-full gap-x-5 items-start justify-start ">
                                <div className="flex flex-col w-[200px]">
                                    <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                        Дата подведения итогов
                                    </label>
                                    <input
                                        type="date"
                                        className={`form-input user-input-placeholder w-full`}
                                        value={
                                            props.purchase?.placing_procedure?.summingup_date_time?.slice(
                                                0,
                                                10
                                            ) || ''
                                        }
                                        style={{
                                            colorScheme:
                                                props.theme == 'dark'
                                                    ? 'dark'
                                                    : 'light',
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col w-full items-start justify-start ">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Место подведения итогов
                                </label>
                                <textarea
                                    className={`form-textarea w-full`}
                                    maxLength={2000}
                                    rows={3}
                                    value={
                                        props.purchase?.placing_procedure
                                            ?.summingup_place || ''
                                    }
                                />
                            </div>
                        </>
                    )}
                    <div className="flex flex-col w-full items-start justify-start ">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Порядок подведения итогов
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <textarea
                            className={`form-textarea w-full`}
                            maxLength={2000}
                            rows={3}
                            value={props.purchase?.summingup_order || ''}
                        />
                    </div>
                </div>
            </fieldset>
        </Section>
    )
}

export default PurchaseSummingup
